module.exports = __webpack_public_path__ + "img/bull_time.892b6eb7.gif";